export default function PHP_is_dir() {
  return (
    <div>
      <h1>PHP_is_dir</h1>
    </div>
  );
}
